import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiAuthLoginRequestParams,
	IApiAuthLoginRequestBody,
	IApiAuthLoginResponseData,

	IApiAuthLogoutResponseData,

	IApiAuthCurrentResponseData,
} from './types';

export class AuthApi extends BaseApi {

	async login(options: IRequestOptions<IApiAuthLoginRequestParams, IApiAuthLoginRequestBody>) {
		const { body } = options;

		return this.post<IApiAuthLoginRequestBody, IApiAuthLoginResponseData>({
			url: getParametrizedUrl(URLS_API.AUTH_LOGIN),
			data: body,
		});
	}

	async logout() {
		return this.post<Record<string, string>, IApiAuthLogoutResponseData>({
			url: getParametrizedUrl(URLS_API.AUTH_LOGOUT),
		});
	}

	async current() {
		return this.get<Record<string, string>, IApiAuthCurrentResponseData>({
			url: getParametrizedUrl(URLS_API.AUTH_CURRENT),
		});
	}

}
